import {authAxios} from "../api/axiosClient";
import {systemInfoURL} from "../constants";

const systemInfoApi = (params) => {
        const url = systemInfoURL;
        return authAxios().get(url,{params});
}
export default systemInfoApi;